import apiClient from '../api';
import { Show, DashboardData } from '../../types';

export const showService = {
  // Get all shows for user (or for an athlete when coach passes viewAs)
  getShows: async (viewAs?: string): Promise<Show[]> => {
    const params = viewAs ? { viewAs } : {};
    const response = await apiClient.get('/shows', { params });
    return response.data;
  },

  // Get active show with full details (backend route is /shows/current)
  getActiveShow: async (): Promise<Show | null> => {
    try {
      const response = await apiClient.get('/shows/current');
      return response.data;
    } catch (error: any) {
      if (error.response?.status === 404) return null;
      throw error;
    }
  },

  // Get show by ID
  getShow: async (id: string): Promise<Show> => {
    const response = await apiClient.get(`/shows/${id}`);
    return response.data;
  },

  // Create new show
  createShow: async (show: Partial<Show>): Promise<Show> => {
    const response = await apiClient.post('/shows', show);
    return response.data;
  },

  // Update show
  updateShow: async (id: string, show: Partial<Show>): Promise<Show> => {
    const response = await apiClient.put(`/shows/${id}`, show);
    return response.data;
  },

  // Delete show
  deleteShow: async (id: string): Promise<void> => {
    await apiClient.delete(`/shows/${id}`);
  },

  // Get dashboard data (supports ?viewAs=userId for coach read-only access)
  getDashboardData: async (viewAs?: string): Promise<DashboardData> => {
    const params = viewAs ? { viewAs } : {};
    const response = await apiClient.get('/shows/dashboard', { params });
    return response.data;
  },
};
